import InternalRoutes from './components/InternalRoutes';
import ExternalRoutes from './components/ExternalRoutes';
import Routes from './Routes';

export { InternalRoutes, ExternalRoutes, Routes };
